import {connect} from 'react-redux';
import InspectedFirmPage from './InspectedFirmPage';
import {getListByFirm} from '../../actions/getListByFirm';
import {setPage} from '../../actions/setPage';

const mapStateToProps = ({
  inspectionsByFirmList: {list, page, totalPages, totalResultCount}
                         }) => ({
  list, page, totalPages, totalResultCount
});

export default connect(
  mapStateToProps,
  {setPage, getListByFirm}
)(InspectedFirmPage);
